import { render, staticRenderFns } from "./MaterialTypeList.vue?vue&type=template&id=941285a4&scoped=true&"
import script from "./MaterialTypeList.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941285a4",
  null
  
)

export default component.exports